import { Component, Input, inject, ChangeDetectorRef } from '@angular/core';
import { AnalyticsExportService } from '@shared/services/api/analytics-export.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-machine-inventory-view',
  templateUrl: './machine-inventory-view.component.html',
  styleUrl: './machine-inventory-view.component.scss'
})
export class MachineInventoryView {
  @Input() filters?: Record<string, any[]> | null = null;
  private readonly exportService = inject(AnalyticsExportService);
  private readonly cdr = inject(ChangeDetectorRef);

  isExporting = false;

  onExportFormatSelected(format: 'csv' | 'pdf', query: string): void {
    this.isExporting = true;

    this.exportService
      .export(query, this.filters ?? null, format)
      .pipe(
        finalize(() => {
          this.isExporting = false;
          this.cdr.markForCheck();
        })
      )
      .subscribe({
        error: (err: any) => {
          console.error(`Error exporting ${format.toUpperCase()}`, err);
        }
      });
  }
}
